import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=bdcaa59e&scoped=true"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"
import style0 from "./Live.vue?vue&type=style&index=0&id=bdcaa59e&prod&lang=css"
import style1 from "./Live.vue?vue&type=style&index=1&id=bdcaa59e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcaa59e",
  null
  
)

export default component.exports